import { Controller } from "@hotwired/stimulus"

// Typeahead for attaching an existing player to a manually-created entry.
//
// The input debounces keystrokes into the results turbo-frame's src, so the
// server renders matches as HTML (no JSON API). Each result button carries the
// player's data and dispatches #select, which records the user id in a hidden
// field, shows the chosen player, and — if the entry name is still blank —
// seeds it from the player so the director doesn't have to retype it.
export default class extends Controller {
  static targets = ["input", "userId", "results", "selected", "selectedLabel"]
  static values = { url: String, debounce: { type: Number, default: 250 } }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.runSearch(), this.debounceValue)
  }

  // Enter in the search box must not submit the surrounding entry form; run the
  // lookup immediately instead.
  submitOnEnter(event) {
    event.preventDefault()
    clearTimeout(this.timeout)
    this.runSearch()
  }

  runSearch() {
    const query = this.inputTarget.value.trim()
    if (query === "") {
      this.clearResults()
      return
    }
    this.resultsTarget.src = `${this.urlValue}?q=${encodeURIComponent(query)}`
  }

  select(event) {
    const { userId, label, name } = event.currentTarget.dataset

    this.userIdTarget.value = userId
    this.selectedLabelTarget.textContent = label
    this.selectedTarget.classList.remove("hidden")
    this.inputTarget.value = ""
    this.clearResults()
    this.seedName(name)
  }

  clear() {
    this.userIdTarget.value = ""
    this.selectedTarget.classList.add("hidden")
    this.selectedLabelTarget.textContent = ""
    this.inputTarget.focus()
  }

  clearResults() {
    this.resultsTarget.removeAttribute("src")
    this.resultsTarget.innerHTML = ""
  }

  seedName(name) {
    if (!name) return
    const nameField = this.element
      .closest("form")
      ?.querySelector("input[name='entry[name]']")
    if (nameField && nameField.value.trim() === "") nameField.value = name
  }
}
